import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { deleteAllVolumetricMaterials } from "#modules/materials/infra/deleteAllVolumetricMaterials.api";
import { materialsQuery } from "#modules/materials/infra/materials.query";

export const useDeleteAllVolumetricMaterials = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteAllVolumetricMaterials,
    onSuccess: () => {
      void queryClient.invalidateQueries(materialsQuery());
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { deleteAllVolumetricMaterials: mutate, ...rest };
};
